<template>
  <div
    class="questionnaire-result-answer__evaluation"
    :class="
      isCorrectAnswer
        ? 'questionnaire-result-answer__evaluation--is-correct'
        : 'questionnaire-result-answer__evaluation--is-wrong'
    "
  >
    <bpb-icon
      class="questionnaire-result-answer__evaluation-icon"
      :icon="answerIcon"
      :decorative="true"
    ></bpb-icon>
    <span>
      <a-label path="questionnaire.answer.yoursWas" :is-visible="true"></a-label
      >&nbsp;
      <a-label
        v-if="isCorrectAnswer"
        path="questionnaire.answer.correct"
        :is-visible="true"
      ></a-label>
      <a-label
        v-else
        path="questionnaire.answer.wrong"
        :is-visible="true"
      ></a-label
      >.</span
    >
  </div>
</template>

<script>
export default {
  inject: ['solution', 'formContext'],
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    isCorrectAnswer() {
      let isCorrect = false;
      this.solution[this.name].forEach(solution => {
        if (this.formContext.fields[this.name] === solution) isCorrect = true;
      });
      return isCorrect;
    },
    answerIcon() {
      return this.isCorrectAnswer ? 'i-checkmark' : 'i-close';
    },
  },
};
</script>
